import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useContactPersonReadQuery, useLeadByIdQuery } from 'api';

export const useContactPersons = () => {
  const { id } = useParams() as { id: string };
  const { data: leadDetails = {}, isLoading: loadingDetails } = useLeadByIdQuery({ id }, { skip: !id });
  const { data: contactPersons = [], isLoading: loadingContacts } = useContactPersonReadQuery(
    { entityId: leadDetails?.client?.id },
    { skip: !id }
  );
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [expandedPersons, setExpandedPersons] = useState<Set<string>>(new Set());

  const toggleDrawer = useCallback(() => {
    setDrawerVisible((prev) => !prev);
  }, []);

  const toggleExpandPerson = useCallback((personId: string) => {
    setExpandedPersons((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(personId)) {
        newSet.delete(personId);
      } else {
        newSet.add(personId);
      }
      return newSet;
    });
  }, []);

  const isPersonExpanded = useCallback(
    (personId: string) => {
      return expandedPersons.has(personId);
    },
    [expandedPersons]
  );

  return {
    contactPersons,
    drawerVisible,
    toggleDrawer,
    leadDetails,
    toggleExpandPerson,
    isPersonExpanded,
    loading: loadingDetails || loadingContacts,
  };
};
